export default __webpack_public_path__ + "static/media/filter.32a088b1.svg";